// import { ActionConfirmation } from 'Components/campaigns/applications/ApplicationCard'
// import CloseButton from 'Components/Common/CloseButton'
import InstagramCaption from 'Components/Common/InstagramCaption'
import { usePrivileges } from 'hooks/useAuth'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { Modal } from 'reactstrap'
// import { processCollaboration as processCollaborationAPI, processCollaborationMilestoneMedia } from 'services/api/campaign/collaboration'
// import { updatePostStatus } from 'slices/campaigns/collaborations/reducer'
import { fetchPost, fetchSocialPostThunk } from 'slices/influencer/thunk'
import { closeInfluencerPostModal } from 'slices/ui/reducer'
import { AppDispatch, RootState } from 'store'
import { Influencer, SocialAccount } from 'types/influencer'
import PerfectScrollbar from 'react-perfect-scrollbar'
import CloseButton from 'Components/Common/CloseButton'
import userProfilePicture from "../../assets/images/users/user-dummy-img.jpg"

interface InfluencerPostModalProps {
    isOpen: boolean,
    onClose: (processed?: boolean) => void,
    influencer?: Influencer,
    socialAccount: SocialAccount,
    postId: string | null,
    status?: 'pending' | 'approved' | 'rejected' | 'processing'
    milestoneStep?: string | null
}

const InfluencerPostModal: React.FC<InfluencerPostModalProps> = ({ isOpen, onClose, postId, status, influencer, milestoneStep=null, socialAccount }) => {

    const { campaignId, milestoneId } = useParams();

    const dispatch: AppDispatch = useDispatch();
    const socialAccountId = socialAccount?.uuid;

    const privileges = usePrivileges();

    const post = useSelector((state: RootState) => state.influencers.social_posts[socialAccount?.uuid]?.[postId!]?.post);
    const [postStatus, setPostStatus] = useState<'pending' | 'approved' | 'rejected' | 'processing' | undefined>(status);

    // const [actionConfirmation, setActionConfirmation] = useState<null | ActionConfirmation>(null);

    useEffect(() => {
        setPostStatus(status)   
    }, [status])

    useEffect(() => {
        if (postId && socialAccountId){
            // setActionConfirmation(null);
            dispatch(fetchSocialPostThunk({ socialAccountId, postId }));
        }
    }, [dispatch, postId, socialAccountId])

    const onModalClose = (processed=false) => {
        dispatch(closeInfluencerPostModal());
        onClose(processed);
    }

    // const processCollaboration = async (influencerId: string, action: 'accept' | 'reject') => {
    //     if(!campaignId) return;
    //     if (!privileges.includes(PRIVILEGE.CAMPAIGN.APPLICATION.PROCESS)) {
    //         toast.error("You don't have permission to process application!");
    //         return;
    //     }
    //     try {
    //         setPostStatus('processing');
    //         const agencyId = store.getState().auth.selectedAgencyId;
    //         if (!agencyId) throw new Error("Agency not selected!");
    //         const result = await processCollaborationAPI(agencyId, campaignId, influencerId, { action, post_id: postId });
    //         if (result.status && result.collaboration?.status) {
    //             setPostStatus(result.collaboration?.status)
    //             dispatch(updatePostStatus({ campaignId, collaborationId: influencerId, postId, status: result.collaboration?.status }));
    //             onModalClose();
    //         }
            
    //     } catch (error) {
    //         toast.error(getErrorMessage(error, "Failed to process collaboration!"));
    //         setPostStatus('pending');
    //         console.log(error);
    //     }
    // }

    // const processCollaborationMilestone = async (influencerId: string, action: 'accept' | 'reject') => {
    //     if(!campaignId || !milestoneId || !milestoneStep || !postId) return;
    //     if (!privileges.includes(PRIVILEGE.CAMPAIGN.APPLICATION.PROCESS)) {
    //         toast.error("You don't have permission to process application!");
    //         return;
    //     }
    //     try {
    //         setPostStatus('processing');
    //         const agencyId = store.getState().auth.selectedAgencyId;
    //         if (!agencyId) throw new Error("Agency not selected!");
    //         const result = await processCollaborationMilestoneMedia(agencyId, campaignId, influencerId, milestoneId, 
    //             {
    //                 step: milestoneStep,
    //                 action,
    //                 post_id: postId
    //             }
    //         );
    //         if (result.status) {
    //             const status = action === 'accept' ? 'approved' : 'rejected';
    //             setPostStatus(status)
    //             dispatch(updatePostStatus({ campaignId, collaborationId: influencerId, postId, status }));
    //             onModalClose(true);
    //         }
            
    //     } catch (error) {
    //         toast.error(getErrorMessage(error, "Failed to process collaboration!"));
    //         setPostStatus('pending');
    //         console.log(error);
    //     }
    // }

    // const approve = async () => {
    //     if(milestoneId && milestoneStep){
    //         return processCollaborationMilestone(influencer.uuid, 'accept');
    //     }

    //     processCollaboration(influencer.uuid, 'accept');
    // }

    // const reject = async () => {
    //     if(milestoneId && milestoneStep){
    //         return processCollaborationMilestone(influencer.uuid, 'reject');
    //     }
    //     processCollaboration(influencer.uuid, 'reject');
    // }

    return (
        <Modal isOpen={isOpen} toggle={() => onModalClose()} size='lg' className='post-modal'>
            <CloseButton onClose={onModalClose} />
            {
                postId && socialAccount && post &&
                <div className="d-flex flex-column flex-md-row">
                    {
                        post.platform === 'ig' && post.ig &&
                        <>
                            {
                                post?.ig?.media_type === 'VIDEO' &&
                                <video src={post?.ig?.media_url} controls autoPlay className='post' controlsList='nodownload nofullscreen noremoteplayback' />
                            }
                            {
                                (post?.ig?.media_type === 'IMAGE' || post?.ig?.media_type === 'CAROUSEL_ALBUM') &&
                                <img src={post?.ig?.media_url} className='post' />
                            }
                        </>
                    }
                    {
                        post.platform === 'yt' && post.yt &&
                        <>
                            {
                                post?.type === 'VIDEO' &&
                                <iframe
                                    src={post.yt.permalink ? `https://www.youtube.com/embed/${post.yt.permalink.split('/').pop()?.split('?')[0]}` : ""}
                                    className="mw-100 mh-800px align-self-center"
                                    style={{ objectFit: "contain", width: '100%', height: '740px', maxHeight: '75vh' }}
                                    frameBorder="0"
                                    allowFullScreen
                                    title="YouTube video"
                                />
                            }
                        </>
                    }
                    {
                        postStatus === 'approved' && <span className="post-status-badge approved"> <i className="bx bx-check"></i>Approved</span>
                    }
                    {
                        postStatus === 'pending' && <span className="post-status-badge new">New</span>
                    }
                    {
                        postStatus === 'rejected' && <span className="post-status-badge declined"> <i className="bx bx-x"></i>Declined</span>
                    }
                    <div className="post-details">
                        <PerfectScrollbar>
                            <div className='d-flex flex-column p-4 gap-4 mb-5'>
                                <div className="post-profile d-flex gap-3">
                                    <img src={socialAccount?.profile_picture_url ?? userProfilePicture} className="post-influencer-pic" />
                                    <div className="name-and-date d-flex flex-column align-items-start ">
                                        <span className="influencer-name">{influencer?.name ?? socialAccount?.name ?? socialAccount?.handle ?? ""}</span>
                                        <span className='influencer-address'>{post?.posted_on}</span>
                                    </div>
                                </div>
                                <InstagramCaption text={post?.platform === 'ig' ? post?.ig?.caption : post?.platform === 'yt' ? post?.yt?.title : ''} />
                            </div>
                        </PerfectScrollbar>
                        {/* {
                            postStatus === 'pending' &&
                            <React.Fragment>
                                {
                                    actionConfirmation ? (
                                        <div className="confirmation-bar w-100 d-flex justify-content-between align-items-center h-max-content mt-2 position-absolute bottom-0 px-3" onClick={e => e.stopPropagation()}>
                                            <span>Are you sure, You want to {actionConfirmation.action} ?</span>
                                            <div className="d-flex justify-content-end align-items-center gap-2">
                                                <button className="confirmation-btn" onClick={actionConfirmation.onConfirmation}>
                                                    <i className='bx bx-check fs-4 text-success' />
                                                </button>
                                                <button className="confirmation-btn" onClick={e => setActionConfirmation(null)}>
                                                    <i className='bx bx-x fs-4 text-danger' />
                                                </button>
                                            </div>
                                        </div>
                                    ) :
                                        (
                                            <div className="action-bar mt-2 position-absolute bottom-0">
                                                <div className="d-flex jusitfy-content-between align-items-center w-100">
                                                    <button disabled={!privileges.includes(PRIVILEGE.CAMPAIGN.COLLABORATION.PROCESS)} className="theme-btn reject btn-light-danger w-100 action-btn" onClick={() => setActionConfirmation({ action: 'reject', onConfirmation: reject })}><i className='bx bx-x me-1 fs-4' ></i>Reject</button>
                                                    <button disabled={!privileges.includes(PRIVILEGE.CAMPAIGN.COLLABORATION.PROCESS)} className="theme-btn approve btn-light-success w-100 action-btn" onClick={() => setActionConfirmation({ action: 'approve', onConfirmation: approve })}><i className='bx bx-check me-1 fs-4' ></i>Approve</button>
                                                </div>
                                            </div>
                                        )
                                }
                            </React.Fragment>
                        }
                        {
                            postStatus === 'processing' &&
                            <div className="confirmation-bar d-flex justify-content-between align-items-center h-max-content mt-2 position-absolute bottom-0 w-100 px-3" onClick={e => e.stopPropagation()}>
                                <span>Processing...</span>
                                <Spinner size="sm" className='me-2'> Loading... </Spinner>
                            </div>
                        } */}
                    </div>

                </div>
            }
            {
                (!postId || !socialAccount) &&
                <span>No media found!</span>
            }
        </Modal>
    )
}

export default InfluencerPostModal